import React, {useEffect, useState} from "react";
import tw from "tailwind-styled-components";
import { Formik, Form } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import Dropzone from "../Properties/ExcelDropzone";
import { toast } from "react-toastify";

const UploadLeads = ({
  uploadLeadsMutate,
  uploadLeadsLoading,
  setUploadLeads,
  selectedData,
}) => {
  const name = (name) => {
    if (!name) return "";
    const lowerCaseName = name.trim().toLowerCase();
    return lowerCaseName.length > 10
      ? `${lowerCaseName.slice(0, 10)}...`
      : lowerCaseName;
  };

    const [excelData, setExcelData] = useState(undefined);
    const [error, setError] = useState(undefined);
  
    useEffect(() => {
      if (excelData) {
        let isError = false;
        excelData.map((i) => {
          if (i.type !== "text/csv") {
            setError("Please enter correct file format (.csv)");
            isError = true;
            setExcelData(undefined);
            return;
          }
        });
        if (!isError) {
          setError(false);
        }
      }
    }, [error, excelData]);
  
    // const submitExcel = async () => {
    //   AddExcelFileMutate(excelData);
    // };

  const InitialValues = {
    name: selectedData?.name,
    mobile: selectedData?.mobile,
    status: selectedData?.status,
    id: selectedData?.id,
  };

  const SubmitHandler = (values) => {
    if (!excelData) {
      toast.error("Please upload the Leads Sheet.");
      return;
    }
    uploadLeadsMutate(excelData);
  };

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setUploadLeads}>
      <Title>Upload Leads</Title>

      {uploadLeadsLoading && <Loading />}

      {!uploadLeadsLoading && (
        <Formik
          initialValues={InitialValues}
          onSubmit={SubmitHandler}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              <Wrapper>
                <InputGroup>
                  <Label htmlFor="logo">Upload Leads</Label>
                  <div>
                  <Dropzone setExcelData={setExcelData} />
                  </div>
                </InputGroup>

                {selectedData?.logoPath && (
                  <InputGroup>
                    <div className="flex items-center mt-[-15px]">
                      <svg
                        className="h-4 w-4 text-primary-color"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      <a
                        href={selectedData.logoPath}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-primary-color ml-1 text-sm"
                      >
                        {name(selectedData?.name)}/logo.png
                      </a>
                    </div>
                  </InputGroup>
                )}
              </Wrapper>
              <BtnWrapper>
                <SubmitBtn type="submit">Upload</SubmitBtn>
              </BtnWrapper>
            </Form>
          )}
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid gap-6 my-6 px-1 `;
const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div` w-full flex items-center justify-center space-x-10 mt-8`;
export default UploadLeads;
